import { render, staticRenderFns } from "./CompraCuenta.vue?vue&type=template&id=3812fdda&"
import script from "./CompraCuenta.vue?vue&type=script&lang=js&"
export * from "./CompraCuenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports